import Vue from 'vue';
import { getLabelByValue } from '../dictionary/dictionary';

Vue.directive("dic", function (el, binding) {
  console.log(el, binding);
  el.innerText = getLabelByValue(el.innerText, binding.value, "");
});


// WEBPACK FOOTER //
// ./src/directive/dic.js